/**
 * Position de la fenêtre de conversation (ticket #36).
 *
 * Isolée dans son propre module parce que **deux acteurs y touchent** : la
 * fenêtre elle-même quand on la glisse, et `ChatEngine` qui la remet à sa place
 * d'origine à l'ouverture d'une conversation neuve.
 */

export const DOCK_POS_KEY = 'stm-chat-dock-pos';

export type DockPos = { x: number; y: number };

export function lireDockPos(): DockPos | null {
  try {
    const p = JSON.parse(localStorage.getItem(DOCK_POS_KEY) || 'null');
    return typeof p?.x === 'number' && typeof p?.y === 'number' ? p : null;
  } catch {
    return null;
  }
}

export function ecrireDockPos(p: DockPos): void {
  try { localStorage.setItem(DOCK_POS_KEY, JSON.stringify(p)); } catch { /* stockage indisponible */ }
}

/** Retour au coin d'origine (bas à droite) : plus aucune position mémorisée. */
export function oublierDockPos(): void {
  try { localStorage.removeItem(DOCK_POS_KEY); } catch { /* stockage indisponible */ }
  // La fenêtre peut être montée : elle écoute cet événement pour se replacer
  // sans attendre un remontage.
  window.dispatchEvent(new Event('stm-dock-pos-reset'));
}
